export const CONSTANTS = {
  mobileScreenSize: 480,
};
